import React, { Children } from "react";
import { dateStyle } from "../../../components/formatter";

export function MAWBDates({ dates }) {
  if (!Array.isArray(dates) || dates.length === 0) {
    return null;
  }

  return (
    <section
      style={{
        display: "flex",
        justifyContent: "space-around",
        borderBottom: "2px solid var(--input-label)",
        margin: "1rem 2.8rem 1rem 0"
      }}
    >
      {Children.toArray(
        dates.map((item) => {
          return (
            <span
              style={{
                color: "var(--input-label)",
                margin: "10px 0",
                fontSize: "20px",
                fontWeight: "bold"
              }}
            >
            {dateStyle(item)}
          </span>
          );
        })
      )}
    </section>
  );
}


